import src from "IMAGE";
export default { src, width: 3840, height: 2034, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAL0lEQVR42n3DMQ0AMAgEwJ+bGmhSSV3qgqCKBRUEbY+DHw7rJxUcKyq43lSwX1AZRfNDmZuENXAAAAAASUVORK5CYII="};
